// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "option__name-cz_xU";
var _3 = "option__price-3etWJ";
export { _1 as "__esModule", _2 as "option__name", _3 as "option__price" }
export default { "__esModule": _1, "option__name": _2, "option__price": _3 }
